import { render, staticRenderFns } from "./RestrictedWordConfirm.vue?vue&type=template&id=014463a7&"
import script from "./RestrictedWordConfirm.vue?vue&type=script&lang=ts&"
export * from "./RestrictedWordConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports